<template>
  <path
    d="m6.385 5.69.07.057L16 15.293l9.546-9.546a.5.5 0 0 1 .765.638l-.058.07L16.707 16l9.546 9.546a.5.5 0 0 1-.638.765l-.07-.058L16 16.707l-9.546 9.546a.5.5 0 0 1-.765-.638l.058-.07L15.293 16 5.747 6.454a.5.5 0 0 1 .638-.765z"
    fill="#2E3233"
    fill-rule="nonzero"
  />
</template>
